export default __webpack_public_path__ + "static/media/onboarding_organize_ad_3.60df9ed2.png";